module.exports = require("./dist/angular-filter.js");


//////////////////
// WEBPACK FOOTER
// angular-filter (bower component)
// module id = 1451
// module chunks = 0